// extracted by mini-css-extract-plugin
export default {"menu-container":"vdAhq","content-container":"MogYS"};